import pnattention from './assets/pnattention.png'
import pnbrouillard from './assets/pnbrouillard.png'
import pncroisement from './assets/pncroisement.png'
import pnecole from './assets/pnecole.png'
import pnhauteur from './assets/pnhauteur.png'
import pninterdit from './assets/pninterdit.png'
import pnlargeur from './assets/pnlargeur.png'
import pnlongueur from './assets/pnlongueur.png'
import pnpente from './assets/pnpente.png'
import pnpoids from './assets/pnpoids.png'
import pnralentisseur from './assets/pnralentisseur.png'
import pnstop from './assets/pnstop.png'
import pntraffic from './assets/pntraffic.png'
import pntravaux from './assets/pntravaux.png'
import pnviragedroit from './assets/pnviragedroit.png'
import pnviragegauche from './assets/pnviragegauche.png'
import pnverglas from './assets/pnverglas.png'

const icons = {
  pnattention,
  pnbrouillard,
  pncroisement,
  pnecole,
  pnhauteur,
  pninterdit,
  pnlargeur,
  pnlongueur,
  pnpente,
  pnpoids,
  pnralentisseur,
  pnstop,
  pntraffic,
  pntravaux,
  pnviragedroit,
  pnviragegauche,
  pnverglas,
}

export default icons
